import React, { FC, useCallback } from "react"
import { Checkbox } from "dash-styled"

interface PlanPanelAdminFooterProps {
    isVisibleToCustomer: boolean
    onChangeVisibleToCustomer: (value: boolean) => void
}

export const PlanPanelAdminFooter: FC<PlanPanelAdminFooterProps> = ({
    isVisibleToCustomer,
    onChangeVisibleToCustomer
}) => {
    const handleChangeVisibleToCustomer = useCallback(
        () => onChangeVisibleToCustomer(!isVisibleToCustomer),
        [isVisibleToCustomer, onChangeVisibleToCustomer]
    )

    return (
        <div className="bg-rhino-100 p-1 pl-12 flex justify-end text-smoke-610 rounded-b">
            <Checkbox
                variant="modern"
                label="Visible to customer"
                className="mr-2"
                isChecked={isVisibleToCustomer}
                onChange={handleChangeVisibleToCustomer}
            />
        </div>
    )
}
